import { render, staticRenderFns } from "./RealisasiCAPEX.vue?vue&type=template&id=58179afd&scoped=true"
import script from "./RealisasiCAPEX.vue?vue&type=script&lang=js"
export * from "./RealisasiCAPEX.vue?vue&type=script&lang=js"
import style0 from "./RealisasiCAPEX.vue?vue&type=style&index=0&id=58179afd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58179afd",
  null
  
)

export default component.exports